export default __webpack_public_path__ + "static/assets/8304e908f737cd585be285404b957c4a.png";